export const enquiryFormDict = {
  en: {
    realEstateEnquiry: 'Real estate enquiry',
    realEstateEnquiryDesc:
      'Get our immigration expert assistance after filling in the form below',
    submit: 'Submit',
    thanks: 'Thank you',
    weReceivedMessage:
      'We have received your message and will contact you within 2 hours. If you would like a faster response, please contact us:',
    messageLabel: 'Message',
  },
  de: {
    realEstateEnquiry: 'Real estate enquiry',
    realEstateEnquiryDesc:
      'Get our immigration expert assistance after filling in the form below',
    submit: 'Submit',
    thanks: 'Thank you',
    weReceivedMessage:
      'We have received your message and will contact you within 2 hours. If you would like a faster response, please contact us:',
    messageLabel: 'Message',
  },
  ru: {
    realEstateEnquiry: 'Запрос на недвижимость',
    realEstateEnquiryDesc:
      'Получите помощь нашего иммиграционного эксперта, заполнив форму ниже',
    submit: 'Отправить',
    thanks: 'Спасибо',
    weReceivedMessage:
      'Мы получили сообщение и свяжемся с вами в течение 2 часов. Если вы хотите получить ответ быстрее, свяжитесь с нами:',
    messageLabel: 'Комментарий',
  },
  tr: {
    realEstateEnquiry: 'Emlak talebi',
    realEstateEnquiryDesc:
      'Aşağıdaki formu doldurduktan sonra göçmenlik uzmanımızdan yardım alın',
    submit: 'Gönder',
    thanks: 'Teşekkür ederiz',
    weReceivedMessage:
      'Mesajınızı aldık ve 2 saat içinde sizinle iletişime geçeceğiz. Daha hızlı bir yanıt almak isterseniz, lütfen bizimle iletişime geçin:',
    messageLabel: 'Mesaj',
  },
};

const EMPTY_FORM_ANALYTICS = {
  sf_record_type_code: '',
  fr_form_id: '',
};

export const enquiryFormAnalyticsDict = {
  monoimin: {
    en: {
      sf_record_type_code: '012580000005hy1AAA',
      fr_form_id: 'imin-153',
    },
    ru: {
      sf_record_type_code: '0124H000000kMjNQAU',
      fr_form_id: 'imin-152',
    },
    // TODO replace with actual values
    de: EMPTY_FORM_ANALYTICS,
    // TODO replace with actual values
    tr: EMPTY_FORM_ANALYTICS,
  },
  passportivity: {
    en: {
      sf_record_type_code: '0124H000000kMjNQAU',
      fr_form_id: 'passportivity-69',
    },
    ru: {
      sf_record_type_code: '0124H000000kMjNQAU',
      fr_form_id: 'passportivity-68',
    },
    // TODO replace with actual values
    de: EMPTY_FORM_ANALYTICS,
    // TODO replace with actual values
    tr: EMPTY_FORM_ANALYTICS,
  },
};
